export default __webpack_public_path__ + "static/Heart-Sticker-x2-83411a0a7821755c1afae2ac8c17b4be.png";